module.exports = __webpack_public_path__ + "static/media/clara-calculator-plugin.5df1ce6b.png";